import { parseDef } from "../parseDef.js";
export const parseReadonlyDef = (def, refs) => {
    return parseDef(def.innerType._def, refs);
};
